/* eslint-disable indent */
import React from 'react';
import { Link } from 'react-router-dom';
import { Badge } from '@burna/monster-design-system';
import RowItem from 'components/row-item';
import styles from './index.module.scss';

const RowItemSettingList = ({ data }) => {
  return (
    <div className={styles.list}>
      {data?.length > 0
        ? data.map((item, i) => (
            <RowItem key={item.uploadDate} title={i + 1}>
              <RowItem.Actions>
                <RowItem.Action
                  icon="download"
                  as={Link}
                  to={item.url}
                  target="_blank"
                />
                <RowItem.Action
                  icon="copy"
                  value={(window.origin + item.url).replace(
                    /(?!^) (?!$)/g,
                    '%20'
                  )}
                />
              </RowItem.Actions>
              <RowItem.Content>
                <RowItem.ContentItem title="One-Time Download">
                  <Badge
                    type={item.oneTimeDownload ? 'success' : 'gray'}
                    icon={item.oneTimeDownload ? 'check' : 'x'}
                    className={styles.badge}
                  />
                </RowItem.ContentItem>
                <RowItem.ContentItem title="Password">
                  <Badge
                    type={item.password ? 'success' : 'gray'}
                    icon={item.password ? 'lock' : 'x'}
                    className={styles.badge}
                  />
                </RowItem.ContentItem>
                <RowItem.ContentItem title="Expiration Time">
                  {item.expiration
                    ? new Date(item.expiration).toLocaleString()
                    : 'Not Set'}
                </RowItem.ContentItem>
              </RowItem.Content>
            </RowItem>
          ))
        : null}
    </div>
  );
};

export default RowItemSettingList;
